import { all, apply, put, takeLatest } from 'redux-saga/effects'
import { SnackBarMessageType } from '../../../components/layout/snackbar/index'
import { open } from '../snack.bar/actions'
import { push } from 'connected-react-router'
import { IActionType, IAxiosResponse } from '../root.types'
import { FollowUpTypes, IActionCreate, IActionFind, IActionLoad, IActionUpdate } from './types'
import { FollowUp } from '../../application/models/followUp/followUp'
import followUpService from "../../../services/followUp"
import {
    createFollowUpFailure,
    createFollowUpSuccess,
    findFollowUpFailure,
    findFollowUpSuccess,
    loadFollowUpFailure,
    loadFollowUpSuccess,
    updateFollowUpFailure,
    updateFollowUpSuccess
} from './actions'

function* loadFollowUp(action: IActionType<IActionLoad>) {
    try {
        const { paginator,patientId, filter } = action.payload
        const followUps: IAxiosResponse<FollowUp[]> = yield apply(
            followUpService,
            followUpService.getAll,    
            [patientId,paginator,filter]
        )
        yield put(loadFollowUpSuccess(followUps))
    } catch (e) {
        yield put(loadFollowUpFailure())
    }
}   

function* updateFollowUp(action: IActionType<IActionUpdate>) {
    try {
        const { followUp } = action.payload
        const followUps: IAxiosResponse<FollowUp> = yield apply(
            followUpService,
            followUpService.updadeFollowUp,
            [followUp]
        )
        yield put<any>(updateFollowUpSuccess(followUps))
        
    } catch (e) {
        open(
            SnackBarMessageType.ERROR,
            '',
            `Campos obrigatórios não preenchidos`)
        yield put(updateFollowUpFailure(e))
    }
}
function* findFollowUp(action: IActionType<IActionFind>) {
    try {
        const { followUpId,patientId } = action.payload
        const followUp: IAxiosResponse<FollowUp> = yield apply(
            followUpService,
            followUpService.getById,
            [patientId,followUpId]
        )
        yield put<any>(findFollowUpSuccess(followUp))
    } catch (e) {
        yield put(findFollowUpFailure())
    }
}
function* createFollowUp(action: IActionType<IActionCreate>) {
    try {
        const { patientId } = action.payload
        const newFollowUp: IAxiosResponse<FollowUp> = yield apply(
            followUpService,
            followUpService.create,
            [patientId]
        )
        yield put(
            open(
                SnackBarMessageType.SUCCESS,
                '',
                `Salvo acompanhamento com sucesso`)
        )
        yield put<any>(createFollowUpSuccess(newFollowUp))
        yield put(
            push(`/app/home/${newFollowUp.data.patient_id}/followups/${newFollowUp.data.id}`)
        )
    } catch (e) { 
        yield put(
            open(
                SnackBarMessageType.ERROR,
                '',
                `Erro ao salvar acompanhamento`)
        )
        yield put(createFollowUpFailure())
    }
}
export default function* patientSaga() {
    return yield all([
        takeLatest(FollowUpTypes.CREATE_FOLLOWUP_REQUEST, createFollowUp),
        takeLatest(FollowUpTypes.FIND_FOLLOWUP_REQUEST, findFollowUp),
        takeLatest(FollowUpTypes.LOAD_FOLLOWUP_REQUEST, loadFollowUp),
        takeLatest(FollowUpTypes.UPDATE_FOLLOWUP_REQUEST, updateFollowUp),
    ])
}